import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { API_BASE_URL } from '../api';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getImageUrl = (path: string | undefined | null) => {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('//') || path.startsWith('data:')) return path;
  if (path.startsWith('/src/') || path.startsWith('src/')) return path;
  
  // Normalize API_BASE_URL (removing trailing /api)
  const baseUrl = API_BASE_URL.replace(/\/api$/, '').replace(/\/api\/$/, '');
  return `${baseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
};

export function formatDate(dateStr: string) {
  const isEn = typeof document !== 'undefined' && document.documentElement?.getAttribute('lang') === 'en';
  return new Date(dateStr).toLocaleDateString(isEn ? 'en-US' : 'ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function getHijriDate() {
  return new Intl.DateTimeFormat('ar-SA-u-ca-islamic-uma', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date());
}
